import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'

import { ClubsDomainModule } from '@alliance/clubs/domain'
import { ClubsRubricsModule } from '@alliance/clubs/rubrics'
import { ClubsTagsModule } from '@alliance/clubs/tags'
import { ClubsUiDateModule } from '@alliance/clubs/ui/date'
import { ClubsUiViewsModule } from '@alliance/clubs/ui/views'
import { ClubsUtilsModule } from '@alliance/clubs/utils'
import { ClubsPostAuthorModule } from '@alliance/clubs/post-author'

import { PostsListComponent } from './components/list/list.component'

import { BaseCardComponent } from './components/card/base/card.component'
import { CardDesktopComponent } from './components/card/desktop/card-desktop.component'
import { CardMobileComponent } from './components/card/mobile/card-mobile.component'
import { SearchEmptyStateComponent } from './components/empty/search/search-empty-state.component'
import { SortingComponent } from './components/sorting/sorting.component'

import { SharedInfiniteScrollingDirectiveModule } from '@alliance/shared/directives/infinite-scrolling'
import { SharedTranslationModule } from '@alliance/shared/translation'

import { SantaSkeletonLoaderModule } from '@alliance/santa/skeleton-loader'
import { SantaSpinnerLoaderModule } from '@alliance/santa/spinner-loader'
import { SantaSelectModule } from '@alliance/santa/select'

const ClubsModules = [ClubsDomainModule, ClubsRubricsModule, ClubsTagsModule, ClubsUiDateModule, ClubsUiViewsModule, ClubsUtilsModule, ClubsPostAuthorModule]

const SharedModules = [SharedInfiniteScrollingDirectiveModule, SharedTranslationModule]

const SantaModules = [SantaSkeletonLoaderModule, SantaSpinnerLoaderModule, SantaSelectModule]

@NgModule({
  imports: [CommonModule, RouterModule, ...ClubsModules, ...SharedModules, ...SantaModules],
  declarations: [PostsListComponent, BaseCardComponent, CardDesktopComponent, CardMobileComponent, SearchEmptyStateComponent, SortingComponent],
  exports: [PostsListComponent, CardDesktopComponent, CardMobileComponent]
})
export class ClubsPostsModule {}
